import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@swc+helpers@0.5.23_@types+react@19.3.0_next@16.4.3_@babel+core@7.29.7_3a58d23d45de62514feaab7e3348ff3d/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/ui/components/marketing/deferred-decorative-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JournalFilter"] */ "/app/src/ui/components/research/journal-filter.tsx");
